<template>
  <div id="app">
    <Header v-if="mainPage"></Header>
    <router-view/>
    <Footer v-if="mainPage"></Footer>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      mainPage: true,
    };
  },
  methods: {
    isMainPage() {
      return /(^\/home)/.test(this.$router.currentRoute.path);
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.mainPage = this.isMainPage();
      },
    },
  },
};
</script>

<style lang="scss">
</style>
